import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../utils/constants";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";
import { showToast } from "./toastAction";

const getTransactions = (setLoading, page, limit, searchKeys, search, filterData) => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("get", `${Constants.endPoints.getuserTransactions}?page=${page}&limit=${limit}&searchKeys=${JSON.stringify(searchKeys)}
    &searchString=${search}&filterData=${JSON.stringify(filterData)}`);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch({
                type: types.TRANSACTIONS,
                payload: res.data,
                count: res.count
            });
        } else {
            dispatch({
                type: types.TRANSACTIONS,
                payload: [],
                count: 0
            });
        }
    } else {
        dispatch(hideLoaderAction());
        dispatch({
            type: types.TRANSACTIONS,
            payload: [],
            count: 0
        });
    }
};

const getNetworkFee = (data, setData) => async (dispatch, getState) => {
    dispatch(showLoaderAction());

    const res = await api("post", Constants.endPoints.getPrice, data);
    if (res.success && res.data) {
        dispatch(hideLoaderAction());
        dispatch({
            type: types.NETWORK_PRICE,
            payload: res.data,
        });

        // Per-network flat gas fee from Redux store
        const { networkGasFees } = getState().networkGasFees;
        const networkGasFee = networkGasFees?.find(n => n.network === data.network)?.gasFee || 0;

        const rate = res.data.finalRate || res.data.marketRate || 1;

        // Convert amount (BUY: divide, SELL: multiply)
        const convertedAmount = data.tradeType === "BUY"
            ? Number(data.amount) / rate
            : Number(data.amount) * rate;

        // Flat fees: per-network + per-pair (from BE)
        const flatFees = Number(networkGasFee) + Number(res.data.pairGasFee || 0);

        // Percentage fees: transaction fee + spread (both from BE)
        const txnFeePercent = Number(res.data.transactionFeePercent) || 0;
        const spreadPercent = Number(res.data.spreadPercent) || 0;
        const percentFees = convertedAmount * ((txnFeePercent + spreadPercent) / 100);

        // Total deductions
        const totalFee = flatFees + percentFees;

        setData((prev) => ({
            ...prev,
            gasFees: totalFee.toFixed(2),
            amountReceived: (convertedAmount - totalFee).toFixed(2),
        }));
    } else if (res.data && (res.data.finalRate || res.data.marketRate)) {
        dispatch(hideLoaderAction());

        // Per-network flat gas fee from Redux store
        const { networkGasFees } = getState().networkGasFees;
        const networkGasFee = networkGasFees?.find(n => n.network === data.network)?.gasFee || 0;

        const rate = res.data.finalRate || res.data.marketRate;

        // Convert amount (BUY: divide, SELL: multiply)
        const convertedAmount = data.tradeType === "BUY"
            ? Number(data.amount) / rate
            : Number(data.amount) * rate;

        // Flat fees: per-network + per-pair (from BE)
        const flatFees = Number(networkGasFee) + Number(res.data.pairGasFee || 0);

        // Percentage fees: transaction fee + spread (both from BE)
        const txnFeePercent = Number(res.data.transactionFeePercent) || 0;
        const spreadPercent = Number(res.data.spreadPercent) || 0;
        const percentFees = convertedAmount * ((txnFeePercent + spreadPercent) / 100);

        // Total deductions
        const totalFee = flatFees + percentFees;

        setData((prev) => ({
            ...prev,
            gasFees: totalFee.toFixed(2),
            amountReceived: (convertedAmount - totalFee).toFixed(2),
        }));
    } else {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "error", summary: res.message || "Could not fetch price" }));
    }
};

const validateWalletAddress = (data) => async (dispatch) => {
    dispatch(showLoaderAction());

    const res = await api("post", Constants.endPoints.validateWalletAddress, data);
    if (res.success) {
        dispatch(hideLoaderAction());
        if (res.data) {
            dispatch(showToast({ severity: "success", summary: res.message }));
            dispatch({
                type: types.VALIDATE_WALLET_ADDRESS,
                payload: res.data,
            });
        } else {
            dispatch(showToast({ severity: "error", summary: res.message }));
            dispatch({
                type: types.VALIDATE_WALLET_ADDRESS,
                payload: false,
            });
        }
    } else {
        dispatch(hideLoaderAction());
        dispatch(showToast({ severity: "error", summary: res.message }));
        dispatch({
            type: types.VALIDATE_WALLET_ADDRESS,
            payload: false,
        });
    }
};

export { getTransactions, getNetworkFee, validateWalletAddress };